export default __webpack_public_path__ + "a27701664bec435b17a7faf389f6cdb5.png";